import {ICar} from "@/modules/Car/interfaces/car.interface";
import {ActionContext} from "vuex";
import {IAppState} from "@/interfaces/app-state.interface";
import {ICarRequest} from "@/modules/Car/interfaces/car-request.interface";
import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";

export namespace ICarStore {
  type CarStoreType = ActionContext<ICarStore.IState, IAppState>;

  export interface ICarStoreModule {
    namespaced: boolean;
    state: ICarStore.IState;
    mutations: {
      setProperty(state: ICarStore.IState, payload: { name: string, value: any }): void;
      setSubProperty(state: ICarStore.IState, payload: { block: string, name: string, value: any }): void;
      startLoading(state: ICarStore.IState): void;
      stopLoading(state: ICarStore.IState): void;
      setFormProperty(state: ICarStore.IState, payload: { formName: string, name: string, value: any}): void;
      setTableInCarPopup(state: ICarStore.IState, payload: { tableName: ICarPopupTables.CarPopupTables, array: any[] }): void;
      clearTableInCarPopup(state: ICarStore.IState): void;
    };
    getters: any;
    actions: {
      openCarPopup(context: CarStoreType, payload: { carId?: number; carNumber?: string }): Promise<void>;
      closeCarPopup(context: CarStoreType): Promise<void>;
      getCar(context: CarStoreType): Promise<void>;
      prepareCarInfo(context: CarStoreType): Promise<void>;
      saveCarData(context: CarStoreType, payload: ICarStore.ISaveCarPayload): Promise<void>;
      getTable(context: CarStoreType, payload: ICarPopupTables.ICarTableParams): Promise<void>;
    };
  }

  export interface IState {
    activeCar: ICar.IEntity;
    displayPopup: boolean;
    displayContent: boolean;
    popupPayload: IPopupPayload;
    createMode: boolean;

    formData: {
      defaultValues: ICar.IEntity;
      formModel: ICar.IEntity;
      startForm: ICar.IEntity;
    },

    tables: {
      [ICarPopupTables.CarPopupTables.movHistory]?: ICarPopupTables.ICamerasTableItem[],
      [ICarPopupTables.CarPopupTables.eventsLog]?: ICarPopupTables.IArchiveTableItem[],
      [ICarPopupTables.CarPopupTables.movements]?: IMovementsReport.ICarPopupTableItem[],
    };

    loading: boolean;
  }

  export interface IPopupPayload {
    // Required props.
    carId?: number;
    carNumber?: string;

    // Additional.
    closeAction?: Function;
    tabForOpen?: ICar.CarPopupTab;
    createMode?: boolean;
    presetFields?: IPopupPayloadField[];

    // Special data.
    addPayload?: any;
    isGuest?: boolean;

    cashSum?: number;
    cashParkId?: number;

    createTrailer?: boolean;
    createTrailerProps?: IPopupPayloadField[];

    customCreateNotification?: boolean;
  }

  export interface IPopupPayloadField {
    prop: string;
    value: string | number | boolean;
  }

  export interface ISaveCarPayload {
    car: ICar.IEntity;
    command: ICarRequest.Command;
    needUpdate?: boolean;
  }

  export enum Events {
    ReloadCarPopupData = 'car-popup:reloadData',
  }
}